import { useSelector } from 'react-redux';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { selectAuth } from '../store/authSlice';

export const GuardedRoute = () => {
  const { tenantId } = useParams();
  const auth = useSelector(selectAuth);
  if (!auth.access || auth.tenantId !== tenantId) {
    return <Navigate to={`/${tenantId}/login`} replace />;
  }
  return <Outlet />;
};
